import axios from "axios";
import { createToast } from "mosha-vue-toastify";
import "mosha-vue-toastify/dist/style.css";
import TaskStatusComponent from '../../components/TaskStatusTableComponent.vue'
import TaskStatusAddComponent from '../../components/TaskStatusAddComponent.vue'
import Swal from "sweetalert2";
export default {
  name: "Tasks",
  components:{TaskStatusComponent,TaskStatusAddComponent},
  data() {
    return {
      //loader
      loader: "",
      //Timer
      TaskStatusShow:false,
      AddTaskStatusModal:false,
      lastErrorCode: 1,
      TimerObject: {},
      tasksList: [],
      aSingleTask: {
        taskID: 0,
        taskName: "",
        description: "",
        practiceId: 0,
      },
      myData: "",
      EmployeeRolesStr: [],
      updButton: 1,
    };
  },

  methods: {
    closeAddTemplateModal()
    {
      $("#template-name").modal('hide');
    },
    closeTaskStatus()
    {
      this.AddTaskStatusModal = false;
    },
    getTaskStatusTable()
    {
        debugger;
        this.$refs.taskStatusComponent.getTaskStatuses();

    },    
    showTaskStatusTable()
    {
        debugger;
        this.TaskStatusShow=true;
        this.$refs.taskStatusComponent.getTaskStatuses();
        this.AddTaskStatusModal=true;
        $("#manage-status").modal("show");
     
    },
    actionChange(res) {
     //debugger
      this.intDummyComm();
      this.dummyComm.extras = "";
      this.dummyComm.extras1 = res.isCaptured;
      this.dummyComm.extras = res.pndx;
      this.dummyComm.visitId = res.visitId;
      this.dummyComm.resourceName = res.resourceName;
      this.dummyComm.resourceStrVal = res.resourceStrId;
      this.dummyComm.resourceId = res.resourceId;

      let url = "";
      url = this.SERVER + "/VNSPRAAPI/Patient/ResourcePatUpd";

      const myDat = this.dummyComm;
      this.axiosGetData(url, myDat, 4);
    },

    StartLogoutTime() {
      this.TimerObject = setTimeout(() => {
        this.AutoLogout();
      }, this.LogoutTime);
    },
    ResetLogoutTime() {
      clearTimeout(this.TimerObject);
      this.TimerObject = setTimeout(() => {
        this.AutoLogout();
      }, this.LogoutTime);
    },

    handleRole() {
      this.EmployeeRolesStr = localStorage.EmployeeRolesStr;
      this.EmployeeRolesStr = JSON.parse(this.EmployeeRolesStr);
      if (this.EmployeeRolesStr.length > 0) {
        this.val = this.EmployeeRolesStr.filter((i) => i.name == "Resource");
        if (this.val[0].canCreate == 0) {
          $('button[name="nam1').hide();
        }
        if (this.val[0].canUpdate == 0) {
          $('button[name="createRes_btn').hide();
        }
        if (this.val[0].canDelete == 0) {
          $("resourcesArchive").hide();
        }
      }
    },

    CreateTask() {
      if(this.aSingleTask.taskName=="")
      {
        this.ShowWarning("Task Name is require");
        event.preventDefault();
        return;
      }
      this.intDummyComm();
      const obj = {
        dc: this.dummyComm,
        tasks: {
          TaskName: this.aSingleTask.taskName,
          Description: this.aSingleTask.description,
          practiceId: this.dummyComm.prId,
        },
      };

      this.CreateTaskAxios(obj);
    },
    async CreateTaskAxios(obj) {
      this.loader = this.$loading.show({
        // Optional parameters
        color: "#03a9f3",
      });
      const url = this.SERVER + "/VNSPRAAPI/Tasks/AddTasks";
      await axios({
        method: "post",
        url: url,
        data: obj, headers:{
          Authorization: this.$store.getters.getAuthToken,
        }
      })
        .then((res) => {
          // if everything goes well -- we will get data
         //debugger
          this.loader.hide();
          this.lastErrorCode = 1;
          const data = res.data;
          if (data.auditFlag === 1) {
            this.showSuccessToast("Task Create.", 4000);
            $("#taskid").modal("hide");
            this.loadInit();
          } else if (data.auditFlag <= 0) {
            this.showErrorToast("Unable To Create Task.", 4000);
          }
          $("#createRes_btn").prop("disabled", false);
        })
        .catch(function (error) {
          if (error.response) {
            this.lastErrorCode = 1;
            alert("-> " + error.response.data);
            alert("-> " + error.response.status);
            alert("-> " + error.response.headers);
          } else if (error.request) {
            this.lastErrorCode = 1;
            alert("No response " + error.request);
          } else {
            this.lastErrorCode = 1;
            alert("Error", error.message);
          }
        })
        .finally(() => {
          this.ResetLogoutTime();
        });
    }, // axiosGetData
    async GetTaskById(task) {
      this.dummyComm.extras = task.taskID;
      this.loader = this.$loading.show({
        // Optional parameters
        color: "#03a9f3",
      });
      const url = this.SERVER + "/VNSPRAAPI/Tasks/GetTaskById";
      await axios({
        method: "post",
        url: url,
        data: this.dummyComm, headers:{
          Authorization: this.$store.getters.getAuthToken,
        }
      })
        .then((res) => {
          // if everything goes well -- we will get data
         //debugger
          this.loader.hide();
          this.lastErrorCode = 1;
          const dc = res.data.dc;
          const myTask = res.data.tasks;
          if (dc.auditFlag === 1) {
            this.aSingleTask.taskID = myTask.taskID;
            this.aSingleTask.taskCode = myTask.taskCode;
            this.aSingleTask.taskName = myTask.taskName;
            this.aSingleTask.description = myTask.description;
            this.aSingleTask.practiceId = myTask.practiceId;
            $("#taskIdEdit").modal("show");
          } else if (dc.auditFlag <= 0) {
            this.showErrorToast("Unable To Create Task.", 4000);
          }
          $("#createRes_btn").prop("disabled", false);
        })
        .catch(function (error) {
          if (error.response) {
            this.lastErrorCode = 1;
            alert("-> " + error.response.data);
            alert("-> " + error.response.status);
            alert("-> " + error.response.headers);
          } else if (error.request) {
            this.lastErrorCode = 1;
            alert("No response " + error.request);
          } else {
            this.lastErrorCode = 1;
            alert("Error", error.message);
          }
        })
        .finally(() => {
          this.ResetLogoutTime();
        });
    },
    async UpdateTask() {
      if(this.aSingleTask.taskName=="")
      {
        this.ShowWarning("Task Name is require");
        event.preventDefault();
        return;
      }
      const obj = {
        dc: this.dummyComm,
        tasks: this.aSingleTask,
      };
      this.loader = this.$loading.show({
        // Optional parameters
        color: "#03a9f3",
      });
      const url = this.SERVER + "/VNSPRAAPI/Tasks/UpdateTasks";
      await axios({
        method: "post",
        url: url,
        data: obj, headers:{
          Authorization: this.$store.getters.getAuthToken,
        }
      })
        .then((res) => {
          // if everything goes well -- we will get data
         //debugger
          this.loader.hide();
          this.lastErrorCode = 1;
          const data = res.data;
          if (data.auditFlag === 1) {
            this.showSuccessToast("Task Create.", 4000);
            $("#taskIdEdit").modal("hide");
            this.loadInit();
          } else if (data.auditFlag <= 0) {
            this.showErrorToast("Unable To Create Task.", 4000);
          }
          $("#createRes_btn").prop("disabled", false);
        })
        .catch(function (error) {
          if (error.response) {
            this.lastErrorCode = 1;
            alert("-> " + error.response.data);
            alert("-> " + error.response.status);
            alert("-> " + error.response.headers);
          } else if (error.request) {
            this.lastErrorCode = 1;
            alert("No response " + error.request);
          } else {
            this.lastErrorCode = 1;
            alert("Error", error.message);
          }
        })
        .finally(() => {
          this.ResetLogoutTime();
        });
    },
    DeleteTask(task) {
      Swal.fire({
        title: "You are about to archive a task.",
        showDenyButton: false,
        showCancelButton: false,
        confirmButtonText: "Ok",
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          Swal.fire({
            title: "Are you sure?",
            text: "This can't be undone",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, Archive this!",
            confirmButtonColor: "#dd6b55",
          }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
              //call delete api here
              this.DeleteTaskAxois(task);
              
            } else if (result.isDenied) {
              Swal.fire("Changes are not saved", "", "info");
            }
          });
        } else if (result.isDenied) {
          Swal.fire("Changes are not saved", "", "info");
        }
      });
    },
    async DeleteTaskAxois(task) {
      const obj = {
        dc: this.dummyComm,
        tasks: task,
      };
      this.loader = this.$loading.show({
        // Optional parameters
        color: "#03a9f3",
      });
      const url = this.SERVER + "/VNSPRAAPI/Tasks/DeleteTasks";
      await axios({
        method: "post",
        url: url,
        data: obj, headers:{
          Authorization: this.$store.getters.getAuthToken,
        }
      })
        .then((res) => {
          // if everything goes well -- we will get data
         //debugger
          this.loader.hide();
          this.lastErrorCode = 1;
          const data = res.data;
          if (data.auditFlag === 1) {
            this.successToastUpd();
            this.loadInit();
          } else if (data.auditFlag <= 0) {
            this.showErrorToast("Unable To Archive Task.", 4000);
          }
          $("#createRes_btn").prop("disabled", false);
        })
        .catch(function (error) {
          if (error.response) {
            this.lastErrorCode = 1;
            alert("-> " + error.response.data);
            alert("-> " + error.response.status);
            alert("-> " + error.response.headers);
          } else if (error.request) {
            this.lastErrorCode = 1;
            alert("No response " + error.request);
          } else {
            this.lastErrorCode = 1;
            alert("Error", error.message);
          }
        })
        .finally(() => {
          this.ResetLogoutTime();
        });
    },
    modalHeader() {
      return this.aSingleTask.taskID <= 0 ? "Resource" : "Update Resource";
    },

    modalButtonCaption() {
      return this.aSingleTask.taskID <= 0 ? "Create" : "Update Resource";
    },
    AddTask() {
      this.aSingleTask.taskID = 0;
      this.aSingleTask.taskName = "";
      this.aSingleTask.description = "";
      $("#taskid").modal("show");
    },
    addResClick(what, ndx) {
      var loader = this.$loading.show({
        // Optional parameters
        color: "#03a9f3",
      });
      if (what === "new") {
        this.aSingleRes.resourceId = 0;
        this.aSingleRes.name = "";
        this.aSingleRes.resourceStrId = "";
        this.aSingleRes.qty = 0;
      } else {
        this.aSingleRes = JSON.parse(JSON.stringify(this.aResList[ndx]));
      }

      $("#resourceID").modal("show");
      loader.hide();
    },

    loader_1() {
      this.loader = this.$loading.show({
        // Optional parameters
        color: "#03a9f3",
      });
    },

    loadInit() {
      this.intDummyComm();
      this.dummyComm.extras = "";
      const url = this.SERVER + "/VNSPRAAPI/Tasks/GetTasksTable";

      this.GetTaskTable(url, this.dummyComm, 1);
      this.StartLogoutTime();
    },
    //------------------------------------------ Common Methods
    async GetTaskTable(myUrl, myData, what) {
      this.loader = this.$loading.show({
        // Optional parameters
        color: "#03a9f3",
      });
      await axios({
        method: "post",
        url: myUrl,
        data: myData,
         headers:{
          Authorization: this.$store.getters.getAuthToken,
        }
      })
        .then((res) => {
          // if everything goes well -- we will get data
         //debugger
          this.lastErrorCode = 1;
          const data = res.data;
          if (data.dc.auditFlag === 1) {
            this.tasksList = data.tasks;
          } else if (data.dc.auditFlag <= 0) {
            this.ShowError("Unable to Fetch Data!");
          }
          $("#createRes_btn").prop("disabled", false);
        })
        .catch(function (error) {
          if (error.response) {
            this.lastErrorCode = 1;
            alert("-> " + error.response.data);
            alert("-> " + error.response.status);
            alert("-> " + error.response.headers);
          } else if (error.request) {
            this.lastErrorCode = 1;
            alert("No response " + error.request);
          } else {
            this.lastErrorCode = 1;
            alert("Error", error.message);
          }
        })
        .finally(() => {
          this.ResetLogoutTime();
          this.loader.hide();
        });
    }, // axiosGetData
  }, // methods

  mounted() {
    if(this.$store.getters.getAuthToken==="")
    {
        this.$store.commit('setAuthToken',localStorage.BeToken);
    }
    clearTimeout(this.loadObj);
    this.handleRole();
    this.loadInit();
  }, // mounted
  unmounted() {
    clearTimeout(this.TimerObject);
  },

  watch: {
    "aSingleRes.resourceStrId": function (val) {
      this.aSingleRes.resourceStrId = val.toUpperCase();
    },

    "aSingleRes.qty": function (val) {
      if (val < 0) this.aSingleRes.qty = 0;
    },

    tasksList: function () {
      $("#clmtable1").DataTable().destroy();
      this.$nextTick(() => {
        try {
          $("#clmtable1").DataTable();
          $(
            ".buttons-copy, .buttons-csv, .buttons-print, .buttons-pdf, .buttons-excel"
          ).addClass("btn btn-primary mr-1");
          $("#clmtable1").DataTable().draw();
        } catch {
          return -1;
        }
      }); // this.$nextTick
    },
  }, // watch
};